import type { JSX } from "react";
import { Navigate } from "react-router-dom";
import { EmptyState, Spinner } from "@mailflare/ui";

import { useAppShell } from "@/app/layout/app-shell";

import { routes } from "@/features/mailboxes/routes";

/** Sends `/` to the active mailbox's inbox. */
export function MailboxRedirect(): JSX.Element {
  const { mailbox } = useAppShell();
  if (mailbox === null) {
    return (
      <EmptyState
        title="No mailbox yet"
        description="Create a mailbox in Settings."
        className="m-auto"
      />
    );
  }
  return <Navigate to={routes.inbox(mailbox.id)} replace />;
}

/** Sends `/mail/:mailboxId` to that mailbox's inbox. */
export function MailboxIndexRedirect(): JSX.Element {
  const { mailbox } = useAppShell();
  if (mailbox === null) return <Spinner label="Loading mailbox" className="m-auto" />;
  return <Navigate to={routes.inbox(mailbox.id)} replace />;
}
